import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useState} from "react";
import formatPrice from "../../utils/format-price";
import {serviceType} from "../../utils/service-type";
import Hint from "../ui/hint/hint";

const defaultText = 'Не выбрано';


function Step6({number, services}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const carServices = useStore((state) => state.carServices)
    const isCheckedCarService = useStore((state) => state.isCheckedCarService)
    const checkCarService = useStore((state) => state.checkCarService)
    const unCheckCarService = useStore((state) => state.unCheckCarService)

    const getCurrentValue = () => {
        if (!!carServices.length) {
            return carServices.map((item, index) => `${index > 0 ? ', ' : ''}${item.name}`)
        }
        return defaultText;
    }
    const handleCheckboxClick = (serviceId, name) => {
        if (isCheckedCarService(serviceId)) {
            unCheckCarService(serviceId);
        } else {
            checkCarService(serviceId, name);
        }
    }

    if (!services) {
        return null;
    }

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            Дополнительные услуги
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.locations}>
                        {
                            services.map((item) => {

                                if (item.caraddonsitegroup === 'Дополнительные услуги' && !!item.caraddonsitename) {
                                    const price = parseInt(item.caraddonprice);
                                    return (
                                        <div key={item.caraddonid} className={styles.location}
                                             onClick={() => handleCheckboxClick(item.caraddonid, item.caraddonsitename)}>
                                            <div
                                                className={`${styles.multiCheckbox} ${isCheckedCarService(item.caraddonid) && styles.checked}`}/>
                                            <span className={`${styles.heading} p-small-size`}>
                                            {item.caraddonsitename}
                                                {!!price && serviceType(item.caraddontype) === 'one_time' && (` (+${formatPrice(price)})`)}
                                                {!!price && serviceType(item.caraddontype) === 'day' && (` (+${formatPrice(price, ' / cут.')})`)}
                                                {
                                                    !!item.caraddonsitedescr && !!item.caraddonsitedescr.length && (
                                                        <Hint text={item.caraddonsitedescr}/>)
                                                }
                                        </span>
                                        </div>
                                    )
                                }
                                return null;
                            })
                        }
                    </div>
                </div>
            )
        }

    </div>);
}

export default Step6;